import(/* webpackMode: "eager" */ "/home/ubuntu/download/6976ef121beda800149d62b7/cosmeticstore/src/app/not-found.tsx");
